<div class="card">
  <div class="position-absolute top-0 end-0 translate-middle-y pe-3" style="z-index: 10;">
    <select class="form-control d-inline-block w-auto selectpicker rounded-pill"
            [(ngModel)]="selectedView"
            (change)="onViewChange()">
      <option value="daily">Daily</option>
      <option value="weekly">Weekly</option>
      <option value="monthly" selected>Monthly</option>
    </select>
  </div>
  <!-- <div class="card-header flex justify-between items-center" *ngIf="selectedView == 'daily'">
    <div class="exp" >
      <h4 class="text-lg font-semibold">Amazon Web Services India Private Limited charges by service</h4>
    </div>
    <div class="ser mt-4">
      <div>
        <p>Total active services</p>
        <h5><strong>{{totactiveser}}</strong></h5>
      </div>
      <div>
        <p>Total service charges in USD</p>
        <h5 class="text-end"><strong>{{ total | number: '1.2-2' }} USD</strong></h5>
      </div>
    </div>
  </div> -->
  
  <div class="card-body p-0">
    <!-- <div class="section">
      <app-service-chart [currentServices]="services" [previousServices]="prevMonth" [viewType]="selectedView"></app-service-chart>
    </div>

    <div class="modal-header">
      <div class="input-group mb-4 w-50 mt-4">
        <span class="input-group-text bg-white border-end-0">
          <i class="fa-solid fa-magnifying-glass text-muted"></i>
        </span>
        <input type="text" [(ngModel)]="searchTerm" class="form-control border-start-0"
          placeholder="Filter by service or region name" />
      </div>



    </div> -->


    <ng-container *ngIf="filteredTag && selectedView !== 'monthly'">
      <div class="alert alert-info position-relative">
        <button type="button" class="btn-close position-absolute top-0 end-0 m-2" aria-label="Close"
          (click)="clearTagFilter()">
        </button>
        <div>
          <strong>Filtered by Tag:</strong><br />
          <span><strong>Account ID:</strong> {{ filteredTag.accountId }}</span><br />
          <span><strong>Tag Key:</strong> {{ filteredTag.tagKey }}</span><br />
          <span><strong>Tag Value:</strong> {{ filteredTag.tagValue }}</span>
        </div>
      </div>
    </ng-container>
    <!-- <div *ngIf="selectedView == 'daily'" class="d-flex flex-wrap align-items-center justify-content-between p-3 border">
      <div class="d-flex flex-wrap align-items-center gap-4">
        <app-filter-by-tags [showModal]="filteredTag" [monthYear]="monthYear" [accountId]="accountId"
         (tagsFiltered)="onTagsFiltered($event)" *ngIf="selectedView == 'monthly'" >
        </app-filter-by-tags>
        <app-preferences [pref]="preferencesData" [monthYear]="monthYear" [filteredTag]="filteredTag" [selectedView]="selectedView"
          [accountId]="accountId" (pageSizeChange)="handlePageSizeChange($event)"
          (responseToParent)="handlePreferencesResponse($event)">
        </app-preferences>


      </div>
      <div>
        <button class="btn btn-outline-primary" (click)="toggleExpandAll()">
          <i class="fa" [ngClass]="isExpandedAll ? 'fa-square-minus' : 'fa-square-plus'"></i>
          {{ isExpandedAll ? 'Minimize All' : 'Expand All' }}
        </button>
      </div>
    </div> -->
<div class="table-responsive" [ngClass]="{'sticky-service-table': selectedView !== 'monthly'}">

<monthly-component
  [isExpandedAll]="isExpandedAll"
  [monthYear]="monthYear"
  [accountId]="accountId"
  [regionId]="regionId"
  [filteredTag]= "filteredTag"
  (monthlyData)="updateChartData($event)"
  [searchTerm]="searchTerm"
  *ngIf="selectedView == 'monthly'">
</monthly-component>

<weekly-component  
[isExpandedAll]="isExpandedAll" 
[monthYear]='monthYear' 
[accountId]='accountId'  
[regionId]="regionId" 
(monthlyData)="updateChartData($event)"
[searchTerm]="searchTerm"
*ngIf="selectedView == 'weekly'"></weekly-component>

<daily-component  
[isExpandedAll]="isExpandedAll" 
[monthYear]='monthYear' 
[accountId]='accountId'  
[regionId]="regionId" 
(monthlyData)="updateChartData($event)"
[searchTerm]="searchTerm"
*ngIf="selectedView == 'daily'"></daily-component>

    <!-- <table class="table table-hover table-striped" style="border-collapse: collapse;">
      <thead>
        <tr style="border-bottom: 1px solid #dee2e6;">
          <th *ngFor="let header of headers">{{ header.label }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="!filteredList?.length">
          <td colspan="4" class="text-center text-muted py-3">No data found</td>
        </tr>

        <ng-container *ngFor="let service of paginatedList; trackBy: trackByProductCode">
          <tr style="border-bottom: 1px solid #dee2e6;">
            <td>
              <span *ngIf="service.regions?.length" (click)="toggle(service)" class="d-inline-flex align-items-center"
                role="button" style="cursor: pointer;">
                <i class="fa me-1" [ngClass]="service.expanded ? 'fa-minus' : 'fa-plus'"></i>
                {{ service.product_code }}
              </span>
              <span *ngIf="!service.regions?.length">{{ service.product_code }}</span>
            </td>
            <td></td>
            <td><strong>USD {{ service.base_cost | number:'1.2-2' }}</strong></td>
            <td><strong>USD {{ service.final_cost | number:'1.2-2' }}</strong></td>
          </tr>

          <ng-container *ngIf="service.expanded">
            <ng-container *ngFor="let region of service.regions">
              <tr style="border-bottom: 1px solid #dee2e6;">
                <td style="padding-left: 40px;">
                  <span *ngIf="region.product_families?.length" (click)="toggle(region)"
                    class="d-inline-flex align-items-center" role="button" style="cursor: pointer;">
                    <i class="fa me-1" [ngClass]="region.expanded ? 'fa-minus' : 'fa-plus'"></i>
                    {{ region.region }}
                  </span>
                  <span *ngIf="!region.product_families?.length">{{ region.region }}</span>
                </td>
                <td></td>
                <td>USD {{ region.base_cost | number:'1.2-2' }}</td>
                <td>USD {{ region.final_cost | number:'1.2-2' }}</td>
              </tr>

              <ng-container *ngIf="region.expanded">
                <ng-container *ngFor="let pf of region.product_families">
                  <tr style="border-bottom: 1px solid #dee2e6;">
                    <td style="padding-left: 80px;">
                      <span *ngIf="pf.operations?.length" (click)="toggle(pf)" class="d-inline-flex align-items-center"
                        role="button" style="cursor: pointer;">
                        <i class="fa me-1" [ngClass]="pf.expanded ? 'fa-minus' : 'fa-plus'"></i>
                        {{ pf.product_family }}
                      </span>
                      <span *ngIf="!pf.operations?.length">{{ pf.product_family }}</span>
                    </td>
                    <td></td>
                    <td>USD {{ pf.base_cost | number:'1.2-2' }}</td>
                    <td>USD {{ pf.final_cost | number:'1.2-2' }}</td>
                  </tr>

                  <ng-container *ngIf="pf.expanded">
                    <ng-container *ngFor="let op of pf.operations">
                      <tr style="border-bottom: 1px solid #dee2e6;">
                        <td style="padding-left: 120px;">
                          <span *ngIf="op.line_items?.length" (click)="toggle(op)"
                            class="d-inline-flex align-items-center" role="button" style="cursor: pointer;">
                            <i class="fa me-1" [ngClass]="op.expanded ? 'fa-minus' : 'fa-plus'"></i>
                            {{ op.operation }}
                          </span>
                          <span *ngIf="!op.line_items?.length">{{ op.operation }}</span>
                        </td>
                        <td></td>
                        <td>USD {{ op.base_cost | number:'1.2-2' }}</td>
                        <td>USD {{ op.final_cost | number:'1.2-2' }}</td>
                      </tr>

                      <ng-container *ngIf="op.expanded">
                        <ng-container *ngFor="let li of op.line_items">
                          <tr style="border-bottom: 1px solid #dee2e6;">
                            <td style="padding-left: 160px;">
                              {{ li.line_item }}
                            </td>
                            <td>
                              {{ li.total_usage_amount | number:'1.2-2' }} {{ li.unit }}
                            </td>
                            <td>USD {{ li.base_cost | number:'1.2-2' }}</td>
                            <td>USD {{ li.final_cost | number:'1.2-2' }}</td>
                          </tr>
                        </ng-container>
                      </ng-container>

                    </ng-container>
                  </ng-container>

                </ng-container>
              </ng-container>

            </ng-container>
          </ng-container>

        </ng-container>
      </tbody>
    </table> -->
    </div>
  </div>
</div>